import { SVGProps, Ref, forwardRef } from 'react';

export const TramFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 8.667c0 3.334-.303 4.85-1.868 5.516l.532 1.595.074.222h-1.476l-.49-1.472c-.745.104-1.657.139-2.772.139s-2.027-.035-2.772-.139L4.738 16H3.262l.074-.222.531-1.595C2.303 13.517 2 12 2 8.667l.001-.07h11.998zM5.732 10a.933.933 0 1 0 .002 1.867A.933.933 0 0 0 5.732 10m4.53 0a.933.933 0 1 0 .002 1.867.933.933 0 0 0-.001-1.867"
                    fill="currentColor"
                />
                <path
                    d="M10.896 0c.487 0 .927-.012 1.33.155.404.167.706.486 1.05.831l.553.552-.99.99-.553-.552c-.425-.425-.51-.492-.596-.528s-.193-.048-.794-.048H8.7v1.273c4.123.066 5.106.801 5.27 4.523H2.03C2.195 3.474 3.177 2.74 7.3 2.673V1.4H5.104c-.6 0-.707.013-.793.048s-.172.103-.597.529l-.552.551-.99-.99.553-.552c.344-.345.646-.664 1.05-.83C4.177-.013 4.616 0 5.104 0z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
TramFilledSize16Glyph.displayName = 'TramFilledSize16Glyph';
